import React from "react";
import "./Education.css";
function Education() {
  return (
    <>
      <section id="resume" className="resume" style={{ paddingBottom: "4rem" }}>
        <div className="container" data-aos="fade-up">
          <div
            className="section-title"
            style={{ marginBottom: "1rem", marginTop: "8rem" }}
          >
            <h2>Education & Experience</h2>
            <p>
              I am a highly motivated and detail-oriented freelance developer
              and undergraduate student with a passion for front-end
              development. My skills include expertise in ReactJS, Bootstrap,
              and Tailwind CSS, and a solid understanding of programming
              languages such as Java, JavaScript, and Python. I have experience
              working on both individual and group projects, and am known for my
              strong problem-solving skills and ability to work well in a team.
              My constant drive to learn and improve is evident in my ongoing
              pursuit of new technologies and my willingness to share my
              knowledge with others.
            </p>
          </div>
          <div className="text-center"></div>

          <div className="row">
            <div className="col-lg-6">
              <h3 className="resume-title">Summary</h3>
              <div className="resume-item pb-0">
                <h4>Ishan Tharindu</h4>
                <p>
                  <em>
                    Freelance developer and student skilled in front-end
                    development and proficient in various programming languages
                    with experience in individual and group projects. Passionate
                    about learning and sharing knowledge. Hobbies include
                    spending time with friends and exploring new hobbies.
                  </em>
                </p>
                <ul>
                  <li>
                    No.12/P, Pahadahena, Wewaihalagoda, Kekanadura, Matara
                  </li>
                  <li>+94 71 575 1121</li>
                  <li>t.gunawardana864@gmail.com</li>
                </ul>
              </div>

              <h3 className="resume-title">Education</h3>
              <div className="resume-item">
                <h4>
                  Bachelor of Science (BSc) in Computer Science &amp; Technology
                </h4>
                <h5>2020 - Present</h5>
                <p>
                  <em>Uva Wellassa University</em>
                </p>
                <p>
                  During my studies, I gained knowledge in various programming
                  languages including Java, and JavaScript. I also conducted
                  research on machine learning algorithms and their
                  applications, and had the opportunity to participate in
                  hackathons and coding competitions. Through group assignments
                  and projects, I developed presentation and collaboration
                  skills.
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <h3 className="resume-title">Professional Experience</h3>
              <div className="resume-item">
                <h4>Software Engineer Intern</h4>
                <h6>Full-Stack Developer</h6>
                <h5>Mar 2024 - Aug 2024</h5>
                <p>
                  <em>ALDTAN (Pvt) Ltd</em>
                </p>
                <ul>
                  <li>
                    Developed VR scenes using A-Frame, creating custom
                    components for animations and interactivity. Implemented
                    asset management features, including file uploads and
                    downloads, and server-side Zip file creation with Node.js.
                    Secured authentication using JWT for sensitive
                    routes
                  </li>
                  <li>
                    Utilized technologies such as Vue.js, VuetifyJs, Node.js,
                    Sequelize, and MySQL. Also prepared user documentation for
                    the VR scene editor and managed backend services and
                    database interactions with Node.js
                  </li>
                  <li>
                    Developed report generation features using React.js and
                    Node.js, with secure authentication and authorization.
                    Integrated PDF generation by creating RESTful API endpoints
                    with Express.js
                  </li>
                  <li>
                    Conducted code reviews, optimized performance for report
                    generation, and implemented user interfaces for displaying
                    reports
                  </li>
                </ul>
              </div>
              <div className="resume-item">
                <h4>Freelance Developer</h4>
                <h5>Nov 2022 - Jan 2023</h5>
                <p>
                  <em>Parallax Technologies (Pvt) Ltd · Sri Lanka</em>
                </p>
                <ul>
                  <li>
                    Worked closely with team members to understand their
                    requirements needs and developed front-end using
                    technologies like ReactJS, Typescript, and Tailwind CSS
                  </li>
                  <li>
                    Developed web applications, ensuring they were optimized for
                    responsive design
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Education;
